import { CalloutBox } from 'components/Docs/CalloutBox';
import Stripe from "../../../../contents/docs/cdp/sources/_snippets/source-stripe.mdx";
import * as React from 'react';
export default {
  CalloutBox,
  Stripe,
  React
};